import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dialogRefs, (dialogRef, index) => {
    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
      _createCommentVNode("transition v-bind=\"transitionAttrs\""),
      (dialogRef && dialogRef.wrapper === _ctx.name)
        ? (_openBlock(), _createBlock(_resolveDynamicComponent(dialogRef.dialog), _mergeProps({
            key: 0,
            ref_for: true
          }, dialogRef.props, {
            ref_for: true,
            ref: (ref) => (dialogRef.comp = ref)
          }), null, 16 /* FULL_PROPS */))
        : _createCommentVNode("v-if", true),
      _createCommentVNode("/transition")
    ], 64 /* STABLE_FRAGMENT */))
  }), 128 /* KEYED_FRAGMENT */))
}